export default __webpack_public_path__ + "static/media/about-gallery-4-comp.cd86cad7.png";